var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('v-container',[_c('v-row',[_c('v-col',[_c('h2',[_vm._v("Logout")]),_c('LogoutComponent')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }